<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
  {{ data.subject }}
</h2>

<mat-dialog-content class="dialog-layout">
  <div class="email-info">
    <span class="info-line">From: {{ data.from }}</span>
    <span class="info-line">To: {{ data.to }}</span>
    @if (data.cc) {
      <span class="info-line">CC: {{ data.cc }}</span>
    }
  </div>

  <div class="email-body" [innerHTML]="sanitizedBody"></div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" [mat-dialog-close]="false">
    {{ 'SHARED.CLOSE' | translate }}
  </button>
</mat-dialog-actions>